import React from 'react';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import { contactInfo, studioHours } from '../mock';

const Contact = () => {
  const items = [
    { icon: Phone, title: 'Phone', value: contactInfo.phone, href: `tel:${contactInfo.phone}` },
    { icon: Mail, title: 'Email', value: contactInfo.email, href: `mailto:${contactInfo.email}` },
    { icon: MapPin, title: 'Address', value: contactInfo.address, href: `https://maps.google.com/?q=${encodeURIComponent(contactInfo.address)}` },
  ];

  return (
    <section id="contact" className="py-20 md:py-28 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <div className="inline-flex items-center gap-2 bg-pink-50 border border-pink-200 text-pink-600 rounded-full px-3 py-1 text-xs font-semibold tracking-wider mb-4">
            REACH OUT
          </div>
          <h2 className="font-display text-4xl md:text-5xl font-bold text-gray-900">
            Get In <span className="gradient-text">Touch</span>
          </h2>
          <p className="mt-4 text-gray-600 text-lg">We&apos;d love to hear from you</p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8">
          {/* Contact info cards */}
          <div className="grid sm:grid-cols-2 gap-4">
            {items.map((item) => {
              const Icon = item.icon;
              return (
                <a
                  key={item.title}
                  href={item.href}
                  target={item.href.startsWith('http') ? '_blank' : undefined}
                  rel="noopener noreferrer"
                  className="card-lift group flex items-start gap-4 p-5 rounded-2xl border border-pink-100 bg-gradient-to-br from-white to-pink-50/50 hover:border-pink-300"
                >
                  <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-pink-500 to-rose-500 flex items-center justify-center shadow-md shrink-0">
                    <Icon className="h-5 w-5 text-white" />
                  </div>
                  <div className="min-w-0">
                    <div className="font-semibold text-gray-900">{item.title}</div>
                    <div className="text-sm text-gray-600 break-words">{item.value}</div>
                  </div>
                </a>
              );
            })}
          </div>

          {/* Studio Hours */}
          <div className="rounded-2xl border border-pink-100 bg-gradient-to-br from-pink-50 via-white to-rose-50 p-6 md:p-8 shadow-sm">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-pink-500 to-rose-500 flex items-center justify-center shadow-md">
                <Clock className="h-5 w-5 text-white" />
              </div>
              <h3 className="font-display text-2xl font-semibold text-gray-900">Studio Hours</h3>
            </div>
            <ul className="divide-y divide-pink-100">
              {studioHours.map((s) => {
                const isClosed = s.hours.toLowerCase() === 'closed';
                return (
                  <li
                    key={s.day}
                    className="flex items-center justify-between py-3 text-gray-700"
                  >
                    <span className="font-medium">{s.day}</span>
                    <span
                      className={`font-semibold text-sm ${
                        isClosed ? 'text-rose-500' : 'text-pink-600'
                      }`}
                    >
                      {s.hours}
                    </span>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
